import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initMetaPixel, trackMetaPixelPageView } from '@/lib/metaPixel';

/**
 * Owns the Meta Pixel lifecycle: bootstraps it on mount (which fires the
 * initial PageView) and fires PageView on every SPA route change after
 * that. Bundle-based init — see src/lib/metaPixel.ts for why the standard
 * inline snippet can't be used (CSP forbids inline scripts).
 */
const MetaPixelRouteTracker = () => {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    initMetaPixel();
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      // initMetaPixel covers the initial PageView
      isFirstRender.current = false;
      return;
    }
    trackMetaPixelPageView();
  }, [pathname]);

  return null;
};

export default MetaPixelRouteTracker;
